import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const plans = [{
  id: 'basico',
  emoji: '📘',
  name: 'SIC 360',
  desc: '6 Tomos + Bono 1',
  oldPrice: '$49.990',
  price: '$19.990',
  savings: null,
  highlighted: false,
  badges: [],
  url: 'https://checkout.rincondigital.shop/cart/52917830517011:1',
  features: ['Los 6 Tomos completos con actividades', 'Bono 1: Banco de Ejemplos Reales Argentinos', 'Acceso de por vida']
}, {
  id: 'completo',
  emoji: '🏆',
  name: 'PACK COMPLETO',
  desc: '6 Tomos + Resolucionario + 4 Bonos',
  oldPrice: '$69.990',
  price: '$24.990',
  savings: 'AHORRÁS $45.000',
  highlighted: true,
  badges: ['⭐ MÁS ELEGIDO'],
  url: 'https://checkout.rincondigital.shop/cart/54001581719827:1',
  features: ['Los 6 Tomos con actividades y resolucionario completo', 'Bono 1: Banco de Ejemplos Reales Argentinos', 'Bono 2: Clases Salvavidas para Días Caóticos', 'Bono 3: Evaluaciones Listas + Rúbricas Extra', 'Bono 4: Mapa Anual de Contenidos', 'Acceso de por vida y actualizaciones incluidas']
}, {
  id: 'full',
  emoji: '⭐',
  name: 'PACK FULL 360',
  desc: 'SIC 360 + Micro y Macro Economía 360 + 100 Micro-Emprendimientos',
  oldPrice: '$79.990',
  price: '$34.990',
  savings: null,
  highlighted: false,
  badges: ['MAYOR VALOR'],
  url: 'https://checkout.rincondigital.shop/cart/52917897363731:1',
  features: ['Todo lo del Pack Completo', '+ Sistema Completo Micro y Macro Economía 360', '+ 100 Micro-Emprendimientos Ganadores', 'Acceso de por vida y actualizaciones incluidas']
}];
export function PricingSection() {
  const [selected, setSelected] = useState('completo');
  const currentPlan = plans.find(p => p.id === selected)!;
  return <section id="precios" className="py-14 md:py-24 bg-[#1e293b] text-white relative overflow-hidden" data-id="element-89">
      <div className="max-w-xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-90">
        <div className="text-center mb-8 md:mb-12" data-id="element-91">
          <h2 className="text-xs font-bold tracking-widest text-[#d4a017] uppercase mb-2" data-id="element-92">
            PRECIOS
          </h2>
          <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-2" data-id="element-93">
            Elegí tu plan
          </h3>
          <p className="text-sm md:text-base text-slate-400" data-id="element-94">
            Dejá de perder tiempo planificando. Volvé a disfrutar el aula.
          </p>
        </div>

        {/* Plan Cards - Radio Style */}
        <div className="space-y-3 mb-8" data-id="element-95">
          {plans.map(plan => <motion.button key={plan.id} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected(plan.id)} className={`w-full text-left rounded-xl p-4 md:p-5 border-2 transition-all relative ${plan.highlighted && selected === plan.id ? 'border-[#d4a017] bg-[#d4a017]/5' : selected === plan.id ? 'border-slate-400 bg-slate-800' : 'border-slate-700 bg-slate-800/60 hover:border-slate-500'}`} data-id="element-96">
              <div className="flex items-center gap-3" data-id="element-97">
                {/* Radio circle */}
                <div className={`w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center ${selected === plan.id ? 'border-[#d4a017]' : 'border-slate-500'}`} data-id="element-98">
                  {selected === plan.id && <div className="w-2.5 h-2.5 rounded-full bg-[#d4a017]" data-id="element-99"></div>}
                </div>

                {/* Plan info */}
                <div className="flex-1 min-w-0" data-id="element-100">
                  <div className="flex items-center gap-2 flex-wrap" data-id="element-101">
                    <span className="text-lg" data-id="element-102">{plan.emoji}</span>
                    <span className="font-extrabold text-sm md:text-base text-white" data-id="element-103">
                      {plan.name}
                    </span>
                    {plan.badges.map((badge, i) => <span key={i} className="bg-[#d4a017] text-[#0f172a] text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-104">
                        {badge}
                      </span>)}
                    {plan.savings && <span className="bg-red-500/20 text-red-400 text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-105">
                        {plan.savings}
                      </span>}
                  </div>
                  <p className="text-slate-400 text-[11px] md:text-xs mt-0.5" data-id="element-106">
                    {plan.desc}
                  </p>
                </div>

                {/* Price */}
                <div className="text-right shrink-0" data-id="element-107">
                  <div className="text-slate-500 line-through text-xs" data-id="element-108">
                    {plan.oldPrice}
                  </div>
                  <div className="text-2xl md:text-3xl font-extrabold text-white" data-id="element-109">
                    {plan.price}
                  </div>
                </div>
              </div>
            </motion.button>)}
        </div>

        {/* CTA Button */}
        <a href={currentPlan.url} className="block w-full bg-[#d4a017] hover:bg-[#b88a14] text-[#0f172a] font-extrabold text-lg md:text-xl py-4 md:py-5 rounded-xl text-center transition-all transform hover:-translate-y-0.5 shadow-lg shadow-[#d4a017]/20" data-id="element-110">
          SÍ, QUIERO {currentPlan.name} →
        </a>

        <p className="text-center text-slate-500 text-xs italic mt-3" data-id="element-111">
          La opción más elegida por docentes que enseñan en los dos niveles
        </p>

        {/* Dynamic features list */}
        <motion.div key={selected} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25
      }} className="mt-6 bg-slate-800/50 border border-slate-700/50 rounded-xl p-4 md:p-5" data-id="element-112">
          <p className="text-[11px] md:text-xs font-bold text-[#d4a017] uppercase tracking-wider mb-3" data-id="element-113">
            {currentPlan.emoji} {currentPlan.name} incluye:
          </p>
          <ul className="space-y-2" data-id="element-114">
            {currentPlan.features.map((feat, i) => <li key={i} className="flex items-start gap-2 text-xs md:text-sm text-slate-300" data-id="element-115">
                <Check className="text-[#d4a017] shrink-0 mt-0.5" size={14} data-id="element-116" />
                <span data-id="element-117">{feat}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Trust badges */}
        <div className="mt-8 pt-6 border-t border-slate-700/50 flex flex-wrap justify-center gap-4 md:gap-6 text-[11px] md:text-xs font-medium text-slate-400" data-id="element-118">
          <span className="flex items-center gap-1.5" data-id="element-119">🔒 Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-120">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-121">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-122">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}